import axios from "axios";
import { Message } from "element-ui";
import router from '../router/index';

export function axiosFilter(){
  // 超时设定
  axios.defaults.timeout = 10*60*1000;
  // 请求拦截
  axios.interceptors.request.use(config => {
    let token = localStorage.getItem('wenge-skil-token');
    if(token){
      config.headers['wenge-skil-token'] = token;
    }
    return config;
  },err => {
    Message.error("请求超时，请稍后重试。");
    //.catch的时候可以捕捉到错误
    return Promise.reject(err);
  });
  axios.interceptors.response.use(response => {
    let res = response.data;
    if(res.code){
      if(res.code >= 5000 && res.code <= 5002){
        document.location = '/#/login';
        return response;
      }else if(res.code == 403){
        router.push('/403');
      }else if(res.code != 200){
        Message.warning(res.msg);
      }
    }
    return response;
  },error => {
    Message.error("请求超时，请稍后重试。");
    //.catch的时候可以捕捉到错误
    return Promise.reject(error);
  });
}



// WEBPACK FOOTER //
// ./src/axios/axios.js